export default __webpack_public_path__ + "static/media/No4Closed.a28d42c8.jpg";